import React from 'react';
import { Route, Switch } from 'react-router-dom'; 
import { ProfileProvider } from '../contexts/ProfileContext';
import AdminHomePage from '../pages/AppPages/AdminPages/AdminHomePage';
import ConfigurationPage from '../pages/AppPages/AdminPages/ConfigurationPage';
import CreateUserPage from '../pages/AppPages/AdminPages/CreateUserPage';
import BillsPage from '../pages/AppPages/BillsPage';
import AudityPage from '../pages/AppPages/AudityPage';
import HomePage from '../pages/AppPages/HomePage';
import MyNotificationsPage from '../pages/AppPages/MyNotificationsPage';
import OrderPage from '../pages/AppPages/OrderPage';
import PreLogoutPage from '../pages/AuthPages/PreLogoutPage';

const AppRoutes = () => {
  return (
    <ProfileProvider>
      <Switch> 
        <Route exact path='/admin/usuario/crear' component={CreateUserPage} />
        <Route exact path='/admin/configuracion' component={ConfigurationPage} />
        <Route exact path='/admin/' component={AdminHomePage} />
        <Route exact path='/auditoria/' component={AudityPage} />
        <Route path='/portal/orden/:id' component={OrderPage} />
        <Route exact path='/mis-notificaciones/' component={MyNotificationsPage} />
        <Route exact path='/facturas/' component={BillsPage} />
        <Route exact path='/' component={HomePage} />
        <Route exact path="/pre-logout/" component={PreLogoutPage} />
      </Switch>
    </ProfileProvider>
  )
}

export default AppRoutes;